export const PROVIDERS = {
  CELESC: process.env.VUE_APP_PROVIDER == 'CELESC',
  NOVUS: process.env.VUE_APP_PROVIDER == 'NOVUS',
  EQUATORIAL: process.env.VUE_APP_PROVIDER == 'EQUATORIAL',
}

export function whenProvider<T>(provider: keyof typeof PROVIDERS, items: T[]): T[] {
  return PROVIDERS[provider] ? items : []
}

export const PERMISSIONS = {
  PAGES: {
    DASHBOARD_VIEW: 'DASHBOARD_VIEW',
    METER_VIEW: 'METER_VIEW',
    SMC_VIEW: 'SMC_VIEW',
    SERVICE_NOTES_VIEW: 'SERVICE_NOTES_VIEW',
    DOWNLOAD_VIEW: 'DOWNLOAD_VIEW',
    PROCESS_VIEW: 'PROCESS_VIEW',
    BALANCE_VIEW: 'BALANCE_VIEW',
    MANAGEMENT_VIEW: 'MANAGEMENT_VIEW',
    BUILDING_VIEW: 'BUILDING_VIEW',
    BILLING_VIEW: 'BILLING_VIEW',
    MANAGEMENT_TAGS_VIEW: 'MANAGEMENT_TAGS_VIEW',
    MANAGEMENT_FIRMWARE_VIEW: 'MANAGEMENT_FIRMWARE_VIEW',
    MANAGEMENT_GROUPS_VIEW: 'MANAGEMENT_GROUPS_VIEW',
    MANAGEMENT_GATEWAYS_VIEW: 'MANAGEMENT_GATEWAYS_VIEW',
    MANAGEMENT_KEYS_VIEW: 'MANAGEMENT_KEYS_VIEW',
    MANAGEMENT_CLIENTS_VIEW: 'MANAGEMENT_CLIENTS_VIEW',
    MANAGEMENT_MODELS_VIEW: 'MANAGEMENT_MODELS_VIEW',
    PHOTOC_VIEW: 'PHOTOC_VIEW',
    MDX_WATER_VIEW: 'MDX_WATER_VIEW',
    MANAGEMENT_NETWORK_VIEW: 'MANAGEMENT_NETWORK_VIEW',
    PARAMETRIZATION_VIEW: 'PARAMETRIZATION_VIEW',
    MANAGEMENT_CONFIGURATION_VIEW: 'MANAGEMENT_CONFIGURATION_VIEW',
    EFFECTIVENESSANDAVAILABILITY_VIEW: 'EFFECTIVENESSANDAVAILABILITY_VIEW',
    QUALITYPARAMETERS_VIEW: 'QUALITYPARAMETERS_VIEW',
    IAGD_VIEW: 'IAGD_VIEW',
  },
  TABLES: {
    ALARM_VIEW: 'ALARM_VIEW',
    EVENT_VIEW: 'EVENT_VIEW',
    TICKETS_VIEW: 'TICKETS_VIEW',
    COMMAND_VIEW: 'COMMAND_VIEW',
    MASS_MEMORY_VIEW: 'MASS_MEMORY_VIEW',
    QEE_VIEW: 'QEE_VIEW',
    FROZEN_DATA_VIEW: 'FROZEN_DATA_VIEW',
    FISCAL_FASIONAL_VIEW: 'FISCAL_FASIONAL_VIEW',
    BILLING_TABLE_VIEW: 'BILLING_TABLE_VIEW',
    INSTANT_MEASURE_VIEW: 'INSTANT_MEASURE_VIEW',
    ALARM_VOLTAGE_VIEW: 'ALARM_VOLTAGE_VIEW',
    AVERAGE_VARIATION_VIEW: 'AVERAGE_VARIATION_VIEW',
  },
  MANAGE: {
    EDIT_MANAGE: 'EDIT_MANAGE',
    DELETE_MANAGE: 'DELETE_MANAGE',
    CREATE_MANAGE: 'CREATE_MANAGE',
    USER_MANAGE: 'USER_MANAGE',
    DISPLAY_CONFIG_MANAGE: 'DISPLAY_CONFIG_MANAGE',
    ABRUPT_VARIATION_MANAGE: 'ABRUPT_VARIATION_MANAGE',
    DOWNLOAD_MANAGE: 'DOWNLOAD_MANAGE',
    CREATE_METERS: 'CREATE_METERS',
    DELETE_METERS: 'DELETE_METERS',
  },
  COMMANDS: {
    EXECUTE_RELAY_STATE: 'EXECUTE_RELAY_STATE',
    EXECUTE_UPDATE_DATETIME: 'EXECUTE_UPDATE_DATETIME',
    EXECUTE_ENERGY_TOTALIZERS: 'EXECUTE_ENERGY_TOTALIZERS',
    EXECUTE_MASS_MEMORY: 'EXECUTE_MASS_MEMORY',
    EXECUTE_INSTANTANEOUS_READINGS: 'EXECUTE_INSTANTANEOUS_READINGS',
    EXECUTE_QUALITY_PARAMETERS: 'EXECUTE_QUALITY_PARAMETERS',
    EXECUTE_CUT_RECONNECT: 'EXECUTE_CUT_RECONNECT',
    EXECUTE_DOWNLOAD_BASE: 'EXECUTE_DOWNLOAD_BASE',
    EXECUTE_QEE_REPORT_GENERATE: 'EXECUTE_QEE_REPORT_GENERATE',
    EXECUTE_QEE_BATCH_QUALITY_READ_BY_GROUP: 'EXECUTE_QEE_BATCH_QUALITY_READ_BY_GROUP',
    EXECUTE_SET_SMI_VOLTAGE_OUT_INTERVAL: 'EXECUTE_SET_SMI_VOLTAGE_OUT_INTERVAL',
    EXECUTE_SET_SMI_QUEE_INTERVAL: 'EXECUTE_SET_SMI_QUEE_INTERVAL',
    EXECUTE_UPDATE_PERIOD: 'EXECUTE_UPDATE_PERIOD',
    EXECUTE_GET_RELAY: 'EXECUTE_GET_RELAY',
    EXECUTE_SET_RELAY_OFF: 'EXECUTE_SET_RELAY_OFF',
    EXECUTE_SET_RELAY_ON: 'EXECUTE_SET_RELAY_ON',
    EXECUTE_SET_REFERENCE_VOLTAGE: 'EXECUTE_SET_REFERENCE_VOLTAGE',
    EXECUTE_GET_REFERENCE_VOLTAGE: 'EXECUTE_GET_REFERENCE_VOLTAGE',
    EXECUTE_RECOVER_ACTIVE_ENERGY: 'EXECUTE_RECOVER_ACTIVE_ENERGY',
    EXECUTE_GET_NETWORK_TYPE: 'EXECUTE_GET_NETWORK_TYPE',
    EXECUTE_SET_NETWORK_PUBLIC: 'EXECUTE_SET_NETWORK_PUBLIC',
    EXECUTE_SET_NETWORK_PRIVATE: 'EXECUTE_SET_NETWORK_PRIVATE',
    EXECUTE_GET_TECH: 'EXECUTE_GET_TECH',
    EXECUTE_SET_NETWORK_CATM1: 'EXECUTE_SET_NETWORK_CATM1',
    EXECUTE_SET_NETWORK_NBIOT: 'EXECUTE_SET_NETWORK_NBIOT',
    EXECUTE_GET_CELL_ID_AND_IP: 'EXECUTE_GET_CELL_ID_AND_IP',
    EXECUTE_SET_EVENT_QEE_INDICATOR: 'cEXECUTE_SET_EVENT_QEE_INDICATOR',
    EXECUTE_SET_STANDART_FROZEN_DATA: 'EXECUTE_SET_STANDART_FROZEN_DATA',
    EXECUTE_SET_DISPLAY_AUTO: 'EXECUTE_SET_DISPLAY_AUTO',
    EXECUTE_SET_DISPLAY_MANUAL: 'EXECUTE_SET_DISPLAY_MANUAL',
    EXECUTE_SET_DISPLAY_AUTO_MICRO_MAX: 'EXECUTE_SET_DISPLAY_AUTO_MICRO_MAX',
    EXECUTE_SET_DISPLAY_MANUAL_MICRO_MAX: 'EXECUTE_SET_DISPLAY_MANUAL_MICRO_MAX',
    EXECUTE_RECOVER_SHORT_DURATION_ALARMS: 'EXECUTE_RECOVER_SHORT_DURATION_ALARMS',
    RECOVER_FISCAL_PAGE: 'RECOVER_FISCAL_PAGE',
    REQUEST_DIC_FIC_DMIC: 'REQUEST_DIC_FIC_DMIC',
    REQUEST_DIC_FIC_GROUP: 'REQUEST_DIC_FIC_GROUP',
    ALARM_VOLTAGE_LONG_DURATION: 'ALARM_VOLTAGE_LONG_DURATION',
    ALARM_VOLTAGE_SHORT_DURATION: 'ALARM_VOLTAGE_SHORT_DURATION',
    EXECUTE_COMMANDS: 'EXECUTE_COMMANDS',
    EXECUTE_MONITORING: 'EXECUTE_MONITORING',
    EXECUTE_DEVICE_RESET: 'EXECUTE_DEVICE_RESET',
    EXECUTE_INFO_REQUEST: 'EXECUTE_INFO_REQUEST',
    EXECUTE_REQUEST_CONFIGURATION: 'EXECUTE_REQUEST_CONFIGURATION',
    EXECUTE_SET_TARIFF: 'EXECUTE_SET_TARIFF',
    EXECUTE_SET_INTERVAL: 'EXECUTE_SET_INTERVAL',
    EXECUTE_SET_WIFI: 'EXECUTE_SET_WIFI',
    EXECUTE_SET_BROKER: 'EXECUTE_SET_BROKER',
    EXECUTE_GET_HEARTBEAT: 'EXECUTE_GET_HEARTBEAT',
  },
  VEE: {
    GROUPS_VIEW: 'VeeGroupsView',
    GROUPS_MANAGE: 'VeeGroupsManage',
    GROUPS_ADMINISTER: 'VeeGroupsAdminister',
    RULES_VIEW: 'Users',
    RULES_MANAGE: 'Operators',
    RULES_ADMINISTER: 'VeeRulesAdminister',
    SERVICE_REQUESTS_VIEW: 'VeeServiceRequestsView',
    SERVICE_REQUESTS_MANAGE: 'VeeServiceRequestsManage',
    MANUAL_OVERRIDE_EDIT: 'VeeManualOverrideEdit',
    BILLING_READINESS_VIEW: 'VeeExceptionsView',
    BILLING_READINESS_RELEASE: 'VeeBillingReadinessRelease',
    EXCEPTIONS_MANAGE: 'VeeExceptionsManage',
    ESTIMATION_PROPOSALS_VIEW: 'VeeEstimationProposalsView',
    ESTIMATION_PROPOSALS_DECIDE: 'VeeEstimationProposalsDecide',
    ESTIMATION_PROPOSALS_BATCH_DECIDE: 'VeeEstimationProposalsBatchDecide',
    NOTIFICATIONS_VIEW: 'VeeNotificationsView',
    NOTIFICATIONS_MANAGE: 'VeeNotificationsManage',
    EXECUTION_MONITOR_VIEW: 'VeeExecutionsView',
  },
} as const

type ExtractPermissions<T> =
  T extends Record<string, any>
    ? {
        [K in keyof T]: T[K] extends Record<string, any> ? ExtractPermissions<T[K]> : T[K]
      }[keyof T]
    : never

export type UserPermission = ExtractPermissions<typeof PERMISSIONS>

function getAllPermissions(obj: any): UserPermission[] {
  return Object.values(obj).flatMap((value) =>
    typeof value === 'object' && value !== null ? getAllPermissions(value) : value,
  ) as UserPermission[]
}

export const allPermissionsList = getAllPermissions(PERMISSIONS)
